// src/components/UI/components/DropdownMenu/DropdownMenu.tsx

import { Root } from '@radix-ui/react-dropdown-menu';

export const DropdownMenu = Root;
DropdownMenu.displayName = 'DropdownMenu';
